const AcSanitize = (input, character = '') => {
  if (!input) return '';
  return input.replace(/[^A-Z0-9]+/gi, character);
};

export default AcSanitize;
